// extracted by mini-css-extract-plugin
module.exports = {"title":"HeaderContent_title__2aCOq","titleContainer":"HeaderContent_titleContainer__1joiN","titleBadge":"HeaderContent_titleBadge__1eVD-"};